import React, { useEffect, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { apiPublic } from "../lib/api";
import { toast } from "sonner";
import { CheckCircle, Warning } from "@phosphor-icons/react";

export default function Setup() {
  const [status, setStatus] = useState(null);
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    company_name: "Cris Lingerie",
    system_url: typeof window !== "undefined" ? window.location.origin : "",
    api_url: typeof window !== "undefined" ? window.location.origin + "/api" : "",
    admin_name: "Administrador",
    admin_email: "",
    admin_password: "",
  });
  const [submitting, setSubmitting] = useState(false);
  const [done, setDone] = useState(false);
  const nav = useNavigate();

  useEffect(() => {
    (async () => {
      try { setStatus((await apiPublic.get("/setup/status")).data); }
      catch { setStatus({ setup_completed: false, infra: {} }); }
    })();
  }, []);

  const upd = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.admin_email || form.admin_password.length < 6) {
      return toast.error("Email valido e senha de min 6 caracteres");
    }
    setSubmitting(true);
    try {
      await apiPublic.post("/setup/configure", form);
      setDone(true);
      toast.success("Setup concluido!");
      setTimeout(() => nav("/login"), 2000);
    } catch (err) { toast.error(err.response?.data?.detail || "Erro"); }
    finally { setSubmitting(false); }
  };

  if (!status) return <div className="min-h-screen grid place-items-center text-sm tracking-widest uppercase text-[#5C5A57]">Carregando...</div>;
  if (status.setup_completed) return <Navigate to="/login" replace />;
  if (done) {
    return (
      <div className="min-h-screen grid place-items-center bg-[#F5F0EB] p-6">
        <div className="bg-white border border-[#EBE5DF] max-w-md w-full p-10 text-center">
          <CheckCircle size={48} weight="duotone" color="#7B9D7E" className="mx-auto mb-3" />
          <h1 className="font-display text-3xl font-bold tracking-tight">Tudo pronto</h1>
          <p className="text-sm text-[#5C5A57] mt-3">Redirecionando para o login...</p>
        </div>
      </div>
    );
  }

  const infra = status.infra || {};

  return (
    <div className="min-h-screen bg-[#F5F0EB] p-6 md:p-12" data-testid="setup-page">
      <div className="max-w-2xl mx-auto">
        <div className="text-center mb-8">
          <div className="font-display text-3xl font-bold tracking-tight">Banco das Revendedoras</div>
          <div className="text-[11px] tracking-[0.22em] uppercase mt-1 text-[#5C5A57]">Instalacao inicial</div>
        </div>

        <div className="bg-white border border-[#EBE5DF] p-6 mb-6">
          <div className="text-[10px] tracking-[0.2em] uppercase text-[#5C5A57] mb-3">Variaveis de infraestrutura</div>
          <ul className="space-y-2 text-sm">
            <li className="flex items-center gap-2">
              {infra.mongo_configured ? <CheckCircle size={16} color="#7B9D7E" weight="fill" /> : <Warning size={16} color="#8B5E5E" weight="fill" />}
              MongoDB: {infra.mongo_configured ? "OK" : "FALTA configurar MONGO_URL no .env do backend"}
            </li>
            <li className="flex items-center gap-2">
              {infra.jwt_secret_set ? <CheckCircle size={16} color="#7B9D7E" weight="fill" /> : <Warning size={16} color="#8B5E5E" weight="fill" />}
              JWT_SECRET: {infra.jwt_secret_set ? "OK" : "FALTA configurar JWT_SECRET no .env do backend"}
            </li>
            <li className="flex items-center gap-2">
              {infra.cookie_secure ? <CheckCircle size={16} color="#7B9D7E" weight="fill" /> : <Warning size={16} color="#E2B77B" weight="fill" />}
              COOKIE_SECURE: {infra.cookie_secure ? "true (HTTPS)" : "false (apenas para HTTP local)"}
            </li>
            <li className="flex items-center gap-2">
              {infra.openai_key_set ? <CheckCircle size={16} color="#7B9D7E" weight="fill" /> : <Warning size={16} color="#E2B77B" weight="fill" />}
              OpenAI: {infra.openai_key_set ? "OK (IA habilitada)" : "Sem chave (CRM usa templates)"}
            </li>
          </ul>
        </div>

        <form onSubmit={submit} className="bg-white border border-[#EBE5DF] p-8">
          <h2 className="section-title mb-6">Configuracao inicial</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
            <div className="md:col-span-2">
              <label className="block text-[10px] tracking-widest uppercase text-[#5C5A57] mb-1">Nome da empresa *</label>
              <input required className="input-underline" value={form.company_name} onChange={upd("company_name")} data-testid="setup-company-input" />
            </div>
            <div>
              <label className="block text-[10px] tracking-widest uppercase text-[#5C5A57] mb-1">URL do sistema</label>
              <input className="input-underline" value={form.system_url} onChange={upd("system_url")} placeholder="https://app.suaempresa.com" />
            </div>
            <div>
              <label className="block text-[10px] tracking-widest uppercase text-[#5C5A57] mb-1">URL da API</label>
              <input className="input-underline" value={form.api_url} onChange={upd("api_url")} placeholder="https://app.suaempresa.com/api" />
            </div>
            <div>
              <label className="block text-[10px] tracking-widest uppercase text-[#5C5A57] mb-1">Nome do admin</label>
              <input className="input-underline" value={form.admin_name} onChange={upd("admin_name")} />
            </div>
            <div>
              <label className="block text-[10px] tracking-widest uppercase text-[#5C5A57] mb-1">E-mail do admin *</label>
              <input required type="email" className="input-underline" value={form.admin_email} onChange={upd("admin_email")} data-testid="setup-email-input" />
            </div>
            <div className="md:col-span-2">
              <label className="block text-[10px] tracking-widest uppercase text-[#5C5A57] mb-1">Senha do admin * (min 6)</label>
              <input required minLength={6} type="text" className="input-underline" value={form.admin_password} onChange={upd("admin_password")} data-testid="setup-password-input" />
            </div>
          </div>
          <button type="submit" className="brand w-full mt-8" disabled={submitting} data-testid="setup-submit-btn">
            {submitting ? "Configurando..." : "Concluir instalacao"}
          </button>
        </form>

        <div className="text-[10px] tracking-widest uppercase text-[#5C5A57] mt-6 text-center">
          Variaveis criticas (JWT, MongoDB) sao lidas do .env do backend. Edite e reinicie antes de prosseguir.
        </div>
      </div>
    </div>
  );
}
